// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OEa9","content":"styles_content__m51SZ"};